export default {"src":"/_next/static/media/social-instagram.82573f02.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};